export const AUTH_TOKEN = "token";
// export const API_LINK = "http://18.193.110.78:5000";
export const API_LINK = "https://hellofarmer-backend.onrender.com";
// export const API_LINK = "http://localhost:8000";
export const PAYPAL_CLIENT_ID =
  "AQeNYlYbl4awiaXtiiyckk_Jk-bSGaj7XRYSWc5TcMt6X30whTAgPO9tW2_q9bn51CKvTDr91VAOpn1U&currency=EUR&disable-funding=credit,card";
